
import {Component, Prop, Watch} from "vue-property-decorator";
import ProtestoIhtar from "@/components/forms/ProtestoIhtarForm.vue";
import Dates from "@/components/inputs/Dates.vue";
import TasinirBilgisiForm from "@/components/forms/TasinirBilgisiForm.vue";
import IlamBilgileriForm from "@/components/forms/alacak/IlamBilgileriForm.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import {SozlesmeTuru} from "@/enum/SozlesmeTuru";
import Tutar from "@/components/inputs/Tutar.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import ProtestoIhtarForm from "@/components/forms/ProtestoIhtarForm.vue";
import {TakipTipi} from "@/enum/TakipTipi";
import {AbstractFormWizard} from "@/abstract_classes/AbstractFormWizard";
import TasinmazBilgisiForm from "@/components/forms/TasinmazBilgisiForm.vue";
import StepperValidationForm from "@/components/StepperValidationForm.vue";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import Kur from "@/components/inputs/Kur.vue";
import PopUp from "@/components/dialogs/PopUp.vue";
import {PopUpTitle} from "@/enum/PopUpTitle";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import { takipteKdvAlaniniGoster } from "@/helpers/TakipTipiEskiNoHelper";

@Component({
  components: {
    PopUp,
    DovizTakipSekliPicker,
    Kur,
    StepperValidationForm,
    TasinmazBilgisiForm,
    ProtestoIhtarForm,
    ParaBirimiPicker,
    TasinirBilgisiForm,
    IlamBilgileriForm,
    Dates,
    ProtestoIhtar,
    Tutar,
    AsilAlacakKalemiForm,
    AyEkleForm,
  },
})
export default class NoterSenediAlacakFormWizard extends AbstractFormWizard {
  @Prop() takipTipiId!: number;
  @Prop() takipTalebi !: TakipTalebiEntity;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Prop({required: false}) takipTipiEskiNo?: string | number;

  get kdvAlaniniGoster(): boolean {
    return takipteKdvAlaniniGoster(this.takipTipiEskiNo);
  }

  PopUpTitle = PopUpTitle;
  activeStep = 1;
  sozlesmeTuru = SozlesmeTuru;
  paraBirimi = ParaBirimi;
  TakipTipi = TakipTipi;
  dovizTakipSekli = DovizTakipSekli;
  dialog = false;

  stepperHeaders = [
    "Noter Senedi",
    "İhtar",
    "Taşınır/ Taşınmaz Bilgisi",
    "Alacak Kalemi"
  ];
  defaultMahkeme = {
    ilam: 1,
    yargiBirimi: 13,
    dosya: 1
  }

  vadeCheck() {
    this.dialog = true;
  }

  stepCheck() {
    this.dialog = false;
    this.nextStep();
  }

  @Watch('localValue.ihtar_var_mi')
  onIhtarVarMiChange() {
    if (this.localValue.ihtar_var_mi && !this.localValue.ihtarlar) {
      this.localValue.ihtarlar = [];
    } else {
      delete this.localValue.ihtarlar;
    }
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY)
      delete this.localValue.doviz_kur_tarihi;
    this.input();
  }

  mounted() {
    this.$emit('hide-button', true);
    if (!this.localValue.asil_alacaklar) {
      this.localValue.asil_alacaklar = [];
    }
    if (!this.localValue.tasinmazlar && (this.takipTipiId == TakipTipi.ipotekIcraEmri || this.takipTipiId == TakipTipi.ipotekOdemeEmri)) {
      this.localValue.tasinmazlar = [];
    } else {
      this.localValue.tasinirlar = [];
    }
  }
}
